import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import type { ReactNode } from "react";
import { ApiClientError } from "../api/http.js";
import { ToastProvider } from "../ui/Toast.js";
import { notifyUnauthorized } from "./authEvents.js";
import { SessionProvider } from "./session.js";

/** The admin turned on required 2FA mid-session: reload /me so the shell shows the setup gate. */
const ME_QUERY_KEY: ReadonlyArray<string> = ["account", "me"];

function createQueryClient(): QueryClient {
  const client: QueryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (err: unknown): void => {
        if (err instanceof ApiClientError && err.status === 401) {
          notifyUnauthorized();
        }
        if (err instanceof ApiClientError && err.code === "TWO_FACTOR_SETUP_REQUIRED") {
          void client.invalidateQueries({ queryKey: ME_QUERY_KEY });
        }
      }
    }),
    defaultOptions: {
      queries: { retry: false, refetchOnWindowFocus: false, staleTime: 30_000 }
    }
  });
  return client;
}

export function AppProviders(props: { readonly children: ReactNode }): ReactNode {
  const [queryClient] = useState<QueryClient>(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ToastProvider>{props.children}</ToastProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
}
